import { BillingPlanIds, isStarterPlan } from '../enums/billing-plan-ids';
import { Features } from '../constants/features';

const FreePlanFeatureDisplay = {
  hidden: [Features.BarcodeScanning, Features.PackingSlips, Features.ProductCatalog, Features.InventoryManagementBasic],
};

export const StarterPlanFeatureDisplay = {
  hidden: [],
};

export const PlanDisplayMap = {
  [BillingPlanIds.Free2025Q2]: FreePlanFeatureDisplay,
  [BillingPlanIds.Starter2025Q2]: StarterPlanFeatureDisplay,
};

export const getFeatureDisplayForPlan = (billingPlanId) => {
  if (billingPlanId === BillingPlanIds.Free2025Q2) return FreePlanFeatureDisplay;
  if (isStarterPlan(billingPlanId)) return StarterPlanFeatureDisplay;
  return {};
};
